import { Box, styled } from '@mui/material';
import { GREEN, MUT2 } from './tokens';

export const TicksRow = styled(Box)({
  position: 'relative',
  height: '34px',
  marginTop: '10px',
});

// Positioned via inline `left` (percentage matching the slider's own
// index-to-percent math) rather than flex space-between, so each tick lands
// exactly under its corresponding dot/thumb stop — including the first and
// last, which space-between would inset from the true 0%/100% edges.
export const Tick = styled(Box)({
  position: 'absolute',
  top: 0,
  transform: 'translateX(-50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '3px',
  cursor: 'pointer',
});

export const TickLabel = styled('b', {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'compact',
})<{ active?: boolean; compact?: boolean }>(({ theme, active, compact }) => ({
  fontSize: compact ? '11px' : '12.5px',
  fontWeight: active ? 700 : 500,
  color: active ? theme.palette.text.primary : MUT2,
  ...theme.applyStyles('dark', {
    color: active ? theme.palette.text.primary : theme.palette.text.secondary,
  }),
  [theme.breakpoints.down('sm')]: { fontSize: '11px' },
}));

export const TickBonus = styled('span', {
  shouldForwardProp: (prop) =>
    prop !== 'active' && prop !== 'hasBonus' && prop !== 'compact',
})<{ active?: boolean; hasBonus?: boolean; compact?: boolean }>(
  ({ theme, active, hasBonus, compact }) => ({
    fontSize: compact ? '10px' : '11px',
    fontWeight: 600,
    color: active ? GREEN : hasBonus ? '#93b8a3' : '#c3cdd6',
    [theme.breakpoints.down('sm')]: { fontSize: '10px' },
  }),
);
